const Button = ({propertiesButton}) => {

return  (
  propertiesButton.dis ?
  <button type="button" className="font-special font-semibold hover:scale-110 inline-flex items-center px-4 py-2 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center cursor-not-allowed" disabled><svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> 
          {propertiesButton.desc}
  </button>
  :
    <button type={propertiesButton.type} className="text-white bg-bordo hover:bg-cinza-cl-900 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-auto px-5 py-2.5 text-center">{propertiesButton.desc}</button>
  )

  

}

export default Button;